import React from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'
import Button from '@dustin-web/microsite-components/src/button'
import { GetCampaignBannerResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import isPublicConvertedDate from '../utils'
import classnames from 'classnames'
import { WindowBreakpoints } from '@dustin-web/microsite-config'

type Props = {
  breakpoints: WindowBreakpoints
  data: GetCampaignBannerResultQuery
}

export const CampaignBannerInternal = ({ data, breakpoints }: Props) => {
  const campaignData = data?.campaignbanner
  const colorThemeVal = campaignData?.colorTheme === '' ? 'light-red' : campaignData?.colorTheme

  const truncateSentence = (sentence: string, maxLength: number) => {
    if (sentence.length <= maxLength) {
      return sentence
    }

    const words = sentence.split(' ')

    return createTruncatedSentence(words, maxLength)
  }

  const createTruncatedSentence = (words: string[], maxLength: number) => {
    let sentence = ''
    for (let i = 0; i < words.length; i++) {
      const newSentence = (sentence += `${words[i]} `)

      if (newSentence.length >= maxLength) {
        return sentence.trim() + '...'
      }

      sentence += newSentence
    }

    return sentence.trim()
  }

  if (!data || !isPublicConvertedDate(campaignData?.published, campaignData?.unpublished)) {
    return null
  }
  return (
    <div className={classnames(`u-relative t-${colorThemeVal}`)}>
      <a
        href={campaignData?.link?.url}
        aria-label={`${campaignData?.title}. ${campaignData?.text}`}
        className={
          'c-campaign-banner u-button-opacity u-decoration-none d-flex justify-content-between justify-content-sm-center u-py-12 u-px-16 u-px-sm-12 align-items-center u-text-center u-relative'
        }>
        <div className="u-pr-8 u-pr-sm-24 u-pr-lg-48 d-flex d-none align-items-center">
          <span className="u-mr-8 u-mr-lg-12 u-h-32 u-w-32">
            <Icon name={'label'} className="i-32"></Icon>
          </span>
          <span className="u-text-left">
            {campaignData?.title && (
              <p className="h3 u-fs-16 u-fs-md-20 u-mb-0">
                {truncateSentence(campaignData?.title, 30)}
              </p>
            )}
            {campaignData?.text && (
              <p className="u-mb-0 u-fs-14" style={{ lineHeight: 1.3 }}>
                {breakpoints.min.SM
                  ? truncateSentence(campaignData?.text, 60)
                  : truncateSentence(campaignData?.text, 30)}
              </p>
            )}
          </span>
        </div>
        {campaignData?.link && (
          <Button
            text={!breakpoints.max.MD ? campaignData?.buttonText : ''}
            icon={'arrow-right'}
            className={`u-mb-0 u-mr-0 c-campaign-banner--border__${campaignData?.colorTheme}`}
            link={false}></Button>
        )}
      </a>
    </div>
  )
}

export default CampaignBannerInternal
